// TODO: Check if this is valid, will leave like this until someone from backend take a look
export enum MaintenanceTab { Unassigned = 0, Assigned = 1, Completed = 3, Canceled = 4, Incomplete = 5 }